import React from 'react'

import Feature from 'components/Feature'
import Folder from 'components/icons/Folder'
import Safety from 'components/icons/Safety'
import Snowflake from 'components/icons/Snowflake'
import withStyles from 'isomorphic-style-loader/withStyles'

import styles from './styles.module.css'

const features = [
  {
    title: 'Один логин и пароль',
    subtitle:
      'Нет необходимости запоминать множество паролей — достаточно знать всего один',
    Icon: Snowflake
  },
  {
    title: 'Только между нами',
    subtitle:
      'Все ваши данные надежно защищены, они не попадут в руки спамеров и злоумышленников',
    Icon: Safety
  },
  {
    title: 'Все ходы записаны',
    subtitle:
      'История входов покажет, кто и с каких устройств заходил в ваш профиль или пользуется им сейчас',
    Icon: Folder
  }
]

function Features() {
  return (
    <section className={styles.features}>
      {features.map((feature) => (
        <Feature
          title={feature.title}
          subtitle={feature.subtitle}
          Icon={feature.Icon}
          key={feature.title}
        />
      ))}
    </section>
  )
}

export default withStyles(styles)(Features)
